// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from '@react-oauth/google';
import { loginWithFacebook } from '../../utils/facebookSdk';
import { AuthApis } from '../../services/auth';
import { hideLoading, showLoading } from '../../store/features/loadingPage';
import { useAppDispatch } from '../../store';
import { useHistory } from 'react-router-dom';
import { validateEmail } from '../../validations/validateEmail';
import { validateConfirmPassword, validatePassword } from '../../validations/validatePassword';
import BoxRequired from '../../components/common/boxRequired';
import { FaFacebookF, FaTwitter } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import TButton from '../../components/common/button';
import ConfirmEmail from './confirmEmail';
import useMessage from '../../components/common/toast/UseMessage';
import TopHeader from '../../components/common/topHeader';
import { login } from '../../store/features/auth';
import '../login/styles.scss';
import ScrollButton from '../../components/pages/top/backToTop/ScrollButton';
import { CHECK_TERM_POLICY, listsErrorNotShowToast } from '../../constants';
import queryString from 'query-string';
import { validateCheckAge } from '../../validations/validateBirthDay';
import InputMask from '../../components/common/InputMask';

export default function Register() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { openMessageError, openMessage } = useMessage();
  const history = useHistory();
  const search = queryString.parse(history.location.search);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [validationMsg, setValidationMsg] = useState({});
  const [isRegisterSuccess, setRegisterSuccess] = useState(false);
  const [dateTime, setDateTime] = useState('');
  const [checkPolicy, setCheckPolicy] = useState(CHECK_TERM_POLICY.unchecked);

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleChangeCheckboxPolicy = () => {
    setCheckPolicy(
      checkPolicy == CHECK_TERM_POLICY.unchecked
        ? CHECK_TERM_POLICY.checked
        : CHECK_TERM_POLICY.unchecked,
    );
  };

  const moveToLogin = () => {
    history.push('/login');
  };

  const validateAll = () => {
    const error = {
      email: '',
      password: '',
      confirmPassword: '',
      birthday: '',
    };
    error.email = validateEmail(email.trim());
    error.password = validatePassword(password);
    error.confirmPassword = validateConfirmPassword(password, confirmPassword);
    error.birthday = validateCheckAge(dateTime);
    setValidationMsg(error);
    for (let i = 0; i < Object.keys(error).length; i++) {
      if (error[Object.keys(error)[i]] !== '') {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async () => {
    const isValid = validateAll();
    if (!isValid) return;
    const [val1, val2, val3] = dateTime.split('/');
    const newDateString = `${val1}-${val2}-${val3}`;
    dispatch(showLoading());
    try {
      await AuthApis.register({
        email: email,
        password: password,
        password_confirmation: confirmPassword,
        birthday: newDateString,
        policy_flag: checkPolicy,
      });
      setRegisterSuccess(true);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };
  const handleLoginTwitter = async () => {
    dispatch(showLoading());
    try {
      const res = await AuthApis.loginTwitter();
      const { login_url } = res.data;
      if (login_url) {
        window.location = login_url;
      }
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };

  const responseSocial = async (response, type) => {
    const { accessToken } = response;
    dispatch(showLoading());
    try {
      if (accessToken) {
        const formData = {
          provider: type,
          access_token: accessToken,
          policy_flag: checkPolicy,
        };
        const res = await AuthApis.loginSocial(formData);
        const { token } = res.data;
        if (token) {
          dispatch(login(res.data));
          if (search?.callbackUrl) {
            history.push(search?.callbackUrl);
          } else {
            history.push('/');
          }
        } else {
          history.push({
            pathname: '/register-social',
            state: { data: res.data },
          });
        }
      } else {
        openMessage({ message: 'ログインが失敗しました。', variant: 'error' });
        history.push('/register');
      }
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };

  const handleLoginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) =>
      responseSocial({ accessToken: tokenResponse.access_token }, 'google'),
    onError: () => {
      openMessage({ message: 'ログインが失敗しました。', variant: 'error' });
    },
  });

  const handleLoginFacebook = () => {
    loginWithFacebook((authResponse) => {
      responseSocial({ accessToken: authResponse.accessToken }, 'facebook');
    });
  };

  return (
    <>
      <TopHeader title={t('headerRegister')} />
      {isRegisterSuccess ? (
        <ConfirmEmail data={email} />
      ) : (
        <div className="login">
          <div className="main-content">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="form-login form-register">
                <div className="title-login AOTFShinMaruGoPro">{t('titleRegister')}</div>
                <div className="mt-4 formInputGroup">
                  <BoxRequired text={t('txtEmail')} />
                </div>
                <div className="input-group mb-3">
                  <input
                    type="text"
                    maxLength="255"
                    className="form-control NotoSansJP400 fontInput"
                    placeholder="test@example.com"
                    value={email}
                    autoComplete="off"
                    onChange={handleChangeEmail}
                  ></input>
                </div>
                {validationMsg.email && <div className="txt_error">{validationMsg.email}</div>}
                <div className="mt-4 formInputGroup">
                  <BoxRequired text={t('txtPassword')} />
                </div>
                <div className="input-group mb-3">
                  <input
                    type="password"
                    className="form-control NotoSansJP400 fontInput"
                    placeholder="半角英数字8~16文字"
                    value={password}
                    autoComplete="off"
                    onChange={(event) => setPassword(event.target.value)}
                  ></input>
                </div>
                {validationMsg.password && (
                  <div className="txt_error">{validationMsg.password}</div>
                )}
                <div className="mt-4 formInputGroup">
                  <BoxRequired text={t('txtConfirmPassword')} />
                </div>
                <div className="input-group">
                  <input
                    type="password"
                    className="form-control NotoSansJP400 fontInput"
                    placeholder="半角英数字8~16文字"
                    value={confirmPassword}
                    autoComplete="off"
                    onChange={(event) => setConfirmPassword(event.target.value)}
                  ></input>
                </div>
                {validationMsg.confirmPassword && (
                  <div className="txt_error">{validationMsg.confirmPassword}</div>
                )}

                <div className="mt-4 formInputGroup d-flex align-items-center">
                  <BoxRequired text={t('txtBirthDay')} />{' '}
                  <span className="formInput__birthday-note">{t('txtBirthDayNote')}</span>
                </div>
                <InputMask setDateTime={setDateTime} dateTime={dateTime} />
                {validationMsg.birthday && (
                  <div className="txt_error">{validationMsg.birthday}</div>
                )}

                <div className="register-policy d-flex justify-content-center align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={checkPolicy}
                    checked={checkPolicy === CHECK_TERM_POLICY.checked}
                    onChange={handleChangeCheckboxPolicy}
                  />
                  <label className="form-check-label NotoSansJP400 f-12">
                    {' '}
                    くじロードONLINEへの会員登録には、
                    <a href={`${process.env.APP_DOMAIN}terms`} target="_blank">
                      利用規約
                    </a>{' '}
                    および
                    <a href="https://bushiroad-creative.com/pages/policy" target="_blank">
                      プライバシーポリシー
                    </a>{' '}
                    への同意が必要です。
                  </label>
                </div>

                <div className="form-submit">
                  <TButton
                    title={t('buttonRegister')}
                    className="btn-login tertiary btn-register NotoSansJP500"
                    disabled={checkPolicy === CHECK_TERM_POLICY.unchecked}
                    type="submit"
                  />
                </div>
              </div>
            </form>
            <div>
              <div className="form-login-social">
                <div className="title-login-social AOTFShinMaruGoPro">
                  {t('headerRegisterSocial')}
                </div>
                <div className="mt-4">
                  <div className="btn-social">
                    <button type="button" className="btnFacebook" onClick={handleLoginFacebook}>
                      <FaFacebookF className="icon-social" />
                      {t('btnFacebook')}
                    </button>
                    <button type="button" className="btnTwitter" onClick={handleLoginTwitter}>
                      <FaTwitter className="icon-social iconTwitter" />
                      {t('btnTwitter')}
                    </button>
                    <button
                      type="button"
                      className="btnGoogle bg-white"
                      onClick={() => handleLoginGoogle()}
                    >
                      <FcGoogle className="icon-google" />
                      {t('btnGoogle')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="move-to-login d-flex justify-content-center">
              <TButton
                title={t('buttonMoveToLogin')}
                className="btn-login secondary btn-move-to-login NotoSansJP500"
                onClick={moveToLogin}
              />
            </div>
          </div>
        </div>
      )}
      <ScrollButton />
    </>
  );
}
